"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportsAction = /** @class */ (function () {
    function ReportsAction(resources, value) {
        this.value = value;
        this.displayName = resources[value || "None"];
    }
    ReportsAction.None = function (resources) { return new ReportsAction(resources, ""); };
    ReportsAction.History = function (resources) { return new ReportsAction(resources, "History"); };
    ReportsAction.RequestLookup = function (resources) { return new ReportsAction(resources, "RequestLookup"); };
    return ReportsAction;
}());
exports.ReportsAction = ReportsAction;
//# sourceMappingURL=ReportsAction.js.map